/* Formatters & helpers */
export const inr = (v) => {
  if (v === null || v === undefined || isNaN(v)) return "₹—";
  if (Math.abs(v) >= 1e7) return `₹${(v / 1e7).toFixed(2)} Cr`;
  if (Math.abs(v) >= 1e5) return `₹${(v / 1e5).toFixed(2)} L`;
  if (Math.abs(v) >= 1000) return `₹${(v / 1000).toFixed(1)}k`;
  return `₹${Math.round(v).toLocaleString("en-IN")}`;
};

export const inrFull = (v) => {
  if (v === null || v === undefined || isNaN(v)) return "₹—";
  return `₹${Math.round(v).toLocaleString("en-IN")}`;
};

export const num = (v, digits = 1) => {
  if (v === null || v === undefined || isNaN(v)) return "—";
  return Number(v).toFixed(digits);
};

export const intf = (v) => {
  if (v === null || v === undefined || isNaN(v)) return "—";
  return Math.round(v).toLocaleString("en-IN");
};

export const pct = (v, digits = 1) => {
  if (v === null || v === undefined || isNaN(v)) return "—";
  return `${Number(v).toFixed(digits)}%`;
};

export const COLORS = {
  green: "#00FF66",
  yellow: "#FFCC00",
  red: "#FF3333",
  blue: "#00E5FF",
  amber: "#FF9900",
  text: "#FFFFFF",
  textDim: "#8F93A2",
  grid: "#1F212A",
  surface: "#0C0D12",
  border: "#1F212A",
};

export const statusColor = (s) => ({
  green: COLORS.green,
  yellow: COLORS.yellow,
  red: COLORS.red,
}[s] || COLORS.textDim);

export const formatTime = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleTimeString("en-IN", { hour12: false, hour: "2-digit", minute: "2-digit", second: "2-digit" });
};
